import React, { useState } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import ToastCustom from '../components/toast';

const AddProductPage = () => {
  const [product, setProduct] = useState({ name: '', price: '', quantity: '' });
  const [variants, setVariants] = useState([]);
  const [toastMessage, setToastMessage] = useState(null);

  const handleAddProduct = async (e) => {
    e.preventDefault();

    const newProduct = {
      ...product,
      variants,
    };

    try {
      const response = await fetch('https://app.mirzawaleed.com/addproduct.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newProduct),
      });
      const result = await response.json();
      setToastMessage(result.message);

      if (result.success) {
        setTimeout(() => {
          console.log("Product added");
          // Reset the form after successful addition
          setProduct({ name: '', price: '', quantity: '' });
          setVariants([]);
        }, 2000);
      }
    } catch (error) {
      console.error('Error adding product:', error);
    }
  };

  const handleVariantChange = (index, field, value) => {
    const updatedVariants = [...variants];
    updatedVariants[index][field] = value;
    setVariants(updatedVariants);
  };

  const handleAddVariant = () => {
    setVariants([...variants, { name: '', quantity: 0 }]);
  };

  const handleRemoveVariant = (index) => {
    setVariants(variants.filter((_, i) => i !== index));
  };

  return (
    <>
      <Header />
      <div style={{ padding: '80px 20px 20px 20px' }}>
        <h1>Add New Product</h1>
        <form onSubmit={handleAddProduct}>
          <div style={inputGroupStyle}>
            <label>Product Name</label>
            <input
              type="text"
              value={product.name}
              onChange={(e) => setProduct({ ...product, name: e.target.value })}
              required
            />
          </div>
          <div style={inputGroupStyle}>
            <label>Price</label>
            <input
              type="number"
              value={product.price}
              onChange={(e) => setProduct({ ...product, price: e.target.value })}
              required
            />
          </div>

          {variants.length > 0 ? (
            variants.map((variant, index) => (
              <div key={index} style={variantRowStyle}>
                <div style={inputGroupStyle}>
                  <label>Variant Name</label>
                  <input
                    type="text"
                    value={variant.name}
                    onChange={(e) => handleVariantChange(index, 'name', e.target.value)}
                    required
                  />
                </div>
                <div style={inputGroupStyle}>
                  <label>Quantity</label>
                  <input
                    type="number"
                    value={variant.quantity}
                    onChange={(e) => handleVariantChange(index, 'quantity', e.target.value)}
                    required
                  />
                </div>
                <button type="button" onClick={() => handleRemoveVariant(index)} style={deleteButtonStyle}>
                  Delete
                </button>
              </div>
            ))
          ) : (
            <div style={inputGroupStyle}>
              <label>Quantity</label>
              <input
                type="number"
                value={product.quantity}
                onChange={(e) => setProduct({ ...product, quantity: e.target.value })}
                required
              />
            </div>
          )}

          <button type="button" onClick={handleAddVariant} style={addVariantButtonStyle}>
            Add Variant
          </button>

          <button type="submit" style={updateButtonStyle}>
            Add Product
          </button>
        </form>
      </div>
      <Footer />

      {toastMessage && <ToastCustom message={toastMessage} onClose={() => setToastMessage(null)} />}
    </>
  );
};

const inputGroupStyle = {
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'column',
};

const variantRowStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '10px',
};

const deleteButtonStyle = {
  marginLeft: '10px',
  padding: '5px 10px',
  backgroundColor: '#F44336',
  color: '#FFF',
  border: 'none',
  borderRadius: '3px',
  cursor: 'pointer',
};

const addVariantButtonStyle = {
  marginTop: '20px',
  padding: '10px',
  backgroundColor: '#2196F3',
  color: '#FFF',
  border: 'none',
  borderRadius: '3px',
  cursor: 'pointer',
};

const updateButtonStyle = {
  marginTop: '20px',
  padding: '10px',
  backgroundColor: '#4CAF50',
  color: '#FFF',
  border: 'none',
  borderRadius: '3px',
  cursor: 'pointer',
};

export default AddProductPage;
